import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=3b85b4d7"
import script from "./Authorized.vue?vue&type=script&lang=ts"
export * from "./Authorized.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports